import { z } from 'zod';
import { goalIdSchema } from './ids';
import { anchorsSchema } from './key-date';
import { signedMoneySchema } from './money';
import { monthIndexSchema } from './time';

export const GOAL_METRICS = ['netWorth', 'cash'] as const;
export type GoalMetric = (typeof GOAL_METRICS)[number];

/** "Reach `target` of `metric` by month `by`" — evaluated as a probability in Monte Carlo runs. */
export const goalSchema = z.object({
  id: goalIdSchema,
  name: z.string().trim().min(1).max(120),
  metric: z.enum(GOAL_METRICS),
  target: signedMoneySchema,
  by: monthIndexSchema,
  anchors: anchorsSchema('by'),
  /** Compare in real (start-year) money rather than nominal. */
  real: z.boolean(),
});
export type Goal = z.infer<typeof goalSchema>;
